// 会员显示车型
<template>
    <div>
        <van-cell-group>
            <van-cell title="车型" :value="carModelName" is-link @click="showSelCarModel" />
        </van-cell-group>
        <SelCarModel ref="selCarModel" @pick="pickCarModel" />
    </div>
</template>

<script>
import { 
    Cell, 
    CellGroup,
    List } from 'vant'
import SelCarModel from '@/view/components/selcarmodel'
import { getCars } from '@/utils/localutils'

export default {
    name: 'VipCarModel',
    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [List.name]: List,
        SelCarModel
    },
    data() {
        return {
            carModelName: null,
            carModelID: null,
            carSeriesID: null,
            carID: null,
            items: []   // 选择部分
        }
    },
    mounted() {
        this.getData()
        
    },
    methods: {
        getData() {
            const car = getCars()
            if (car != null) {
                const curCar = car.curCar
                this.carModelName = curCar.carcategory_name
                this.carModelID = curCar.carcategory_id
                this.carSeriesID = curCar.series_id
                this.items = car.cars 
            } else {
                console.log('no get car')
            }
        },
        showSelCarModel() {
            // this.$refs.selCarModel.showDialog(this.items)
            this.$refs.selCarModel.showDialog()
        },
        pickCarModel(obj) {
            this.carModelName = obj.carcategory_name
            this.carModelID = obj.carcategory_id
            this.carSeriesID = obj.series_id
            this.carID = obj.car_id
            this.$emit('pick', obj)
        }
    }
}
</script>